import { isEmpty } from 'lodash/fp';
import { Card, Stack } from '@optimus-web/core';
import { isDayUseService } from '@mews-commander/legacy-entities/src/ducks/services';
import {
    isCurrentProfilePlatformAdmin,
    canCurrentProfileManageRestrictions,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { CardDetailListElement } from '../styles';
import ActionColumn from './ActionColumn';
import RestrictionDeleteConfirmationDialog from './RestrictionDeleteConfirmationDialog';
import { ConditionsSection, ExceptionsSection } from './sections';

const RestrictionDetailCard = ({ conditions, exceptions, restrictionId, serviceId, timeUnit }: $TSFixMe) => {
    const isPlatformAdmin = useCommanderSelector(isCurrentProfilePlatformAdmin);
    const canManageRestrictions = useCommanderSelector(canCurrentProfileManageRestrictions);
    const isServiceDayUse = useCommanderSelector((state) => isDayUseService(state, { id: serviceId }));
    const showActionColumn = !isPlatformAdmin && canManageRestrictions;

    return (
        <Card padding="200">
            <Stack spacing="200" fill>
                <CardDetailListElement>
                    <ConditionsSection restrictionId={restrictionId} serviceId={serviceId} {...conditions} />
                    {!isEmpty(exceptions) ? (
                        <ExceptionsSection
                            exceptions={exceptions}
                            timeUnit={timeUnit}
                            isServiceDayUse={isServiceDayUse}
                        />
                    ) : null}
                </CardDetailListElement>
                {showActionColumn ? <ActionColumn restrictionId={restrictionId} serviceId={serviceId} /> : null}
            </Stack>

            <RestrictionDeleteConfirmationDialog ownerId={restrictionId} scope={serviceId} />
        </Card>
    );
};

export default RestrictionDetailCard;
